<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn v-if="hasRoleCadastroProduto"
             color="primary" class="normal-btn-text rounded-tag-small elevation-0"
             link to="/cadastro-unidade-medida">
        <v-icon left>mdi-plus</v-icon>
        Unidade de Medida
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque pela unidade de medida"
                      class="rounded-tag-small" v-model="searchText"
                      style="max-width: 400px"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemUnidadesMedida', ['stringFilter']),
    ...mapGetters('user', ['hasRoleCadastroProduto']),
    searchText: {
      get() {
        return this.$store.getters['listagemUnidadesMedida/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemUnidadesMedida/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter();
    },
    onSelectItem() {
      this.onChangeFilter();
    },
  },
};
</script>
